import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, Card } from '@material-ui/core';
import { Modal } from 'antd';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';
import MainContainer from '../../../components/MainContainer';
import AuditLogListPage from './AuditLogList';
import AuditLogModalPage from './AuditLogModal';
import './AuditLog.css';

@inject(
    'loginStore',
    'AuditLogStore'
)
@observer
class AuditLogPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        this.props.loginStore.authenticateAdmin().then(response => {
          if (!response) {
            this.props.history.push('/admin/login');
          }
        });
    }

    // ON CANCEL

    auditLogModalOnCancel = () => {
        this.props.AuditLogStore.setShowAuditLogModal(false);
    }

    render() {
        const { t } = this.props;
        const {
            showAuditLogModal,
            auditLogTitle,
        } = this.props.AuditLogStore;

        return (
            <MainContainer title={t('Audit Log')} menukey='audit-log'>
                <Modal
                    title={t(auditLogTitle)}
                    visible={showAuditLogModal}
                    width={800}
                    footer={null}
                    onCancel={this.auditLogModalOnCancel}
                    zIndex={1000}
                >
                    <AuditLogModalPage />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: 'auto' }}>
                            <AuditLogListPage />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(AuditLogPage);
